import Component from "@base/js/component";
import getAbsoluteHeight from "@base/js/util/getAbsoluteHeight";
import throttle from "lodash.throttle";

export default class Transcript extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".transcript";

  // Defines children that needs to be queried as part of this component
  static children = {
    content: ".transcript__content", // Queries a single element
    toggler: ".transcript__button",
    articleContent: ".transcript__content-container",
  };

  contentLongModifier = "transcript__content--long";

  isLong = false;

  // Defines event handlers to attach to children
  eventHandlers = {
    toggler: {
      click: this.onToggle,
    },
  };

  // Will be called upon component instantiation
  afterInit() {
    this.checkTogglerViability();

    window.addEventListener("resize", this.updateHeightOnResize);
  }

  checkTogglerViability() {
    const allPs = this.element.querySelectorAll("p");
    const hasMoreThan4Ps = allPs && allPs.length > 4;

    if (hasMoreThan4Ps) {
      this.updateContentHeight();
    } else {
      this.element.classList.add("no-after");
      this.element.querySelector(".transcript__button").remove();
    }
  }

  updateContentHeight() {
    if (!this.children) return;

    let height = this.children.articleContent.offsetHeight;

    if (!this.isLong) {
      const first4Paragraphs = [...this.element.querySelectorAll("p")].splice(
        0,
        4
      );
      const BLUR_OFFSET = 70;

      height =
        first4Paragraphs.reduce(
          (totalHeight, el) => totalHeight + getAbsoluteHeight(el),
          0
        ) + BLUR_OFFSET;
    }

    this.children.content.style.maxHeight = `${height}px`;
  }

  updateHeightOnResize = throttle(() => {
    this.updateContentHeight();
  }, 500);

  onToggle() {
    const { toggler, content } = this.children;
    const { viewFullText, viewShortText } = toggler.dataset;

    if (this.isLong) {
      this.isLong = false;
      toggler.innerText = viewFullText;
      content.classList.remove(this.contentLongModifier);
    } else {
      this.isLong = true;
      toggler.innerText = viewShortText;
      content.classList.add(this.contentLongModifier);
    }

    this.updateContentHeight();
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
Transcript.init();
